// @ts-nocheck
import ROUTES from "../../docRoutes/docRoutes";
import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    LOGOUT,
    NEW_APP_LAUNCH,
} from "../constants/authConstant";
import { userInfoAction } from "./userInfoAction";
import { clearSsoSession, isSsoSession, ssoLogoutUrl } from "../../utils/docGridSso";

export const userLoginAction = (data) => async (dispatch) => {
    try {
        dispatch({ type: LOGIN_REQUEST });
        if (data) {
            dispatch({ type: LOGIN_SUCCESS, payload: data });
        }
    } catch (error) {
        console.error("Login failed:", error);
        dispatch({ type: LOGIN_FAILED, payload: error.message || "Login failed" });
    }
};

export const clearLocalSessionAction = () => {
    return async (dispatch) => {
        await dispatch(userInfoAction({}));
        dispatch({ type: LOGOUT });
        localStorage.removeItem("docGridToken");
        localStorage.removeItem("user_id");
        localStorage.removeItem("userFullName");
        clearSsoSession();
    };
};

// global: the user clicked "Logout". A central-login session is then also
// ended at the IDP, which signs the user out of every product.
// authError: shown on the login page; it also stops the idp-mode
// auto-redirect, so a session the backend keeps rejecting cannot loop
// between DocGrid and the IDP.
export const userLogoutAction = ({ global = false, authError } = {}) => {
    return async (dispatch) => {
        try {
            const endIdpSession = global && isSsoSession();
            await dispatch(clearLocalSessionAction());
            if (endIdpSession) {
                window.location.assign(ssoLogoutUrl);
                return;
            }
            const loginUrl = authError
                ? `${ROUTES.LOGIN}?authError=${encodeURIComponent(authError)}`
                : ROUTES.LOGIN;
            window.history.pushState({}, "", loginUrl);
            window.location.assign(loginUrl);
        } catch (error) {
            console.error("Logout error:", error);
        }
    };
};

export const appVersionChangeAction = () => {
    return async (dispatch) => {
        try {
            localStorage.clear();
            await dispatch({ type: NEW_APP_LAUNCH });
        } catch (error) {
            console.error("Error resetting app version:", error);
        }
    };
};

export const userLoginSuccess = (userData, userInfo) => ({
    type: LOGIN_SUCCESS,
    payload: { userData, userInfo },
});
